export default class Benutzer {
    Prim = 0;
    EMail = 0;
    Name = "";
    Vorname = "";
    Passwort = "";
    Adminbestaetigung = false;
    IstAdmin = false;
    RefVereine = 0;
    Bemerkung = "";
}

